<template>
  <el-row>
    <el-row
      v-for="(rs, i) in row_list"
      :key="i"
    >
      <el-col
        style="text-align:left"
        v-for="(e, ii) in rs"
        :key="i + '_' + ii"
        :span="e.span"
      ><span v-if="e.key != ''"><b>{{ e.key }}</b>：</span>
      <el-link v-if = "!!e.href" type="primary" v-bind:href="e.href" target="_blank">{{ e.val || '-' }}</el-link>
      <span v-else>{{ e.val || '-' }}</span>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
export default {
  props: {
    row_list: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleEditOrder: function (id) {
      this.$emit('editOrder', id)
    }
  }
}
</script>